<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2020-05-08 14:19:42
 * @Description: 组织信息
 -->

<template>
  <div class="organizetion-wrapper">
    <!-- 工商信息 -->
    <div class="content">
      <div class="title">
        <img src="https://files.jinr.com/jinr-index/img/company-title-01.png" alt="" srcset="" />
      </div>
      <div class="table">
        <el-row class="row is-odd" type="flex" align="middle">
          <el-col :span="6" class="col name">平台全称</el-col>
          <el-col :span="6" class="col val">厦门吉才神网络借贷信息中介服务有限公司</el-col>
          <el-col :span="6" class="col name">平台简称</el-col>
          <el-col :span="6" class="col val">鲸鱼</el-col>
        </el-row>
        <el-row class="row" type="flex" align="middle">
          <el-col :span="6" class="col name">统一社会信用代码证</el-col>
          <el-col :span="6" class="col val">91350205302896797R</el-col>
          <el-col :span="6" class="col name">法定代表人</el-col>
          <el-col :span="6" class="col val">任韡旻</el-col>
        </el-row>
        <el-row class="row is-odd" type="flex" align="middle">
          <el-col :span="6" class="col name">注册资本</el-col>
          <el-col :span="6" class="col val">人民币100,000,000.00元</el-col>
          <el-col :span="6" class="col name">实缴注册资本</el-col>
          <el-col :span="6" class="col val">人民币64,437,558.34元</el-col>
        </el-row>
        <el-row class="row" type="flex" align="middle">
          <el-col :span="6" class="col name">注册地址</el-col>
          <el-col :span="6" class="col val">
            中国(福建)自由贸易试验区厦门片区嵩屿南二路99号1335室
          </el-col>
          <el-col :span="6" class="col name">经营地址</el-col>
          <el-col :span="6" class="col val">
            中国(福建)自由贸易试验区厦门片区嵩屿南二路99号1335室
          </el-col>
        </el-row>
        <el-row class="row is-odd" type="flex" align="middle">
          <el-col :span="6" class="col name">成立时间</el-col>
          <el-col :span="6" class="col val">2014年6月18日</el-col>
          <el-col :span="6" class="col name">平台上线运营时间</el-col>
          <el-col :span="6" class="col val">2014年10月</el-col>
        </el-row>
        <el-row class="row is-odd" type="flex" align="middle">
          <el-col :span="6" class="col name">经营期限</el-col>
          <el-col :span="6" class="col val">2014年6月18日 至 2064年6月17日</el-col>
          <el-col :span="6" class="col name">经营状态</el-col>
          <el-col :span="6" class="col val">正常营业</el-col>
        </el-row>
        <el-row class="row" type="flex" align="middle">
          <el-col :span="6" class="col name">实际控制人</el-col>
          <el-col :span="6" class="col val">肖国斌</el-col>
          <el-col :span="6" class="col name">分支机构信息</el-col>
          <el-col :span="6" class="col val">未设置分支机构</el-col>
        </el-row>
        <el-row class="row is-odd" type="flex" align="middle">
          <el-col :span="6" class="col name">经营范围</el-col>
          <el-col :span="18" class="col val special">从事网络借贷信息中介业务</el-col>
        </el-row>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <img src="https://files.jinr.com/jinr-index/img/company-title-02.png" alt="" srcset="" />
      </div>
      <div class="shareholder">
        <el-row class="row is-odd title-name">
          <el-col :span="8" class="col">股东</el-col>
          <el-col :span="8" class="col val">持股比例</el-col>
          <el-col :span="8" class="col">认缴出资额（万元）</el-col>
          <!-- <el-col :span="6" class="col val">实缴出资额（元）</el-col> -->
        </el-row>
        <el-row class="row">
          <el-col :span="8" class="col">武汉康顺集团有限公司</el-col>
          <el-col :span="8" class="col val">51.00%</el-col>
          <el-col :span="8" class="col">5100</el-col>
          <!-- <el-col :span="6" class="col val">30,463,152.42</el-col> -->
        </el-row>
        <el-row class="row">
          <el-col :span="8" class="col">厦门鲸合力企业管理合伙企业（有限合伙）</el-col>
          <el-col :span="8" class="col val">49.00%</el-col>
          <el-col :span="8" class="col">4900</el-col>
          <!-- <el-col :span="6" class="col val">3,761,253.50</el-col> -->
        </el-row>
        <el-row class="row is-odd">
          <el-col :span="8" class="col">合计</el-col>
          <el-col :span="8" class="col val">100%</el-col>
          <el-col :span="8" class="col">10000</el-col>
          <!-- <el-col :span="6" class="col val">63,687,558.34</el-col> -->
        </el-row>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <img
          class="title-img"
          src="https://files.jinr.com/jinr-index/img/company-title-03.png"
          alt=""
          srcset=""
        />
        <img
          class="content-img"
          src="https://files.jinr.com/jinr-index/img/company-img-04.png"
          alt=""
          srcset=""
        />
      </div>
    </div>
    <div class="content">
      <div class="title">
        <img
          class="title-img"
          src="https://files.jinr.com/jinr-index/img/company-title-04.png"
          alt=""
          srcset=""
        />
        <img
          class="content-img"
          src="https://files.jinr.com/jinr-index/img/company-img-05.png"
          alt=""
          srcset=""
        />
      </div>
    </div>
    <div class="content">
      <div class="title">
        <img src="https://files.jinr.com/jinr-index/img/company-title-05.png" alt="" srcset="" />
      </div>
      <div class="text-wrapper">
        <div class="item">
          <h2>任韡旻</h2>
          <h3>总经理兼法人代表</h3>
          <p>
            多年从事于互联网金融产品设计及管理工作，拥有丰富的金融产品构架及运营管理经验。<br />
            统筹管理公司产品的研发、创新及运营，负责公司全面风险管理，合理配置资源。
          </p>
        </div>
        <div class="item">
          <h2>邱臻</h2>
          <h3>风控负责人</h3>
          <p>
            毕业于华南理工大学，曾参与创建多只大型基金，多年金融机构整体战略规划经验。<br />
            对于互联网金融的业务模式创新、信用评价模型和风险管理体系建设有独到的见解和实践经验，并在企业管理和运营上有着丰富的经验。
          </p>
        </div>
        <div class="item">
          <h2>陈宗伟</h2>
          <h3>监事</h3>
          <p>
            拥有多年知名互联网企业管理运作经验，具备卓越的行业发展分析及项目管理经验。<br />
            负责公司重大经营方针、战略目标的制定与决策，监督公司管理体系运行情况。
          </p>
        </div>
        <div class="item">
          <h2>钟镇雄</h2>
          <h3>副总经理</h3>
          <p>
            十年传统金融行业经验，六年互联网金融行业管理经验，对金融和互联网均有丰富的从业经验与其独到的见解。
          </p>
        </div>
        <div class="item">
          <h2>林海燕</h2>
          <h3>财务负责人</h3>
          <p>
            在传统行业和互联网工作多年，拥有丰富财务规划及管理经验。<br />
            主要负责公司全面财务管理及拟定财务相关管理政策及程序，监督公司财务战略规划的实施。
          </p>
        </div>
        <div class="item">
          <h2>邓杨杨</h2>
          <h3>信息技术负责人</h3>
          <p>
            本科毕业于电子信息科学与技术专业，一直从事于互联网行业技术与管理工作，拥有丰富的技术开发和产品线运营经验。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scope>
.organizetion-wrapper {
  .content {
    padding: 40px 0 0;
    text-align: center;
    .content-img {
      width: 100%;
    }
    .title {
      margin: 0px 0 20px;
    }
    .table {
      // text-align: center;
      border: 1px solid #ececec;
      .is-odd {
        background: #fafafa;
      }
      .col {
        min-height: 90px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #575757;
      }
      .val {
        border-left: 1px solid #ececec;
        border-right: 1px solid #ececec;
        color: #247af1;
      }
      .special {
        padding: 10px 10px;
        text-align: left;
        text-indent: 2em;
      }
    }
  }
  .shareholder {
    border: 1px solid #ececec;
    .row {
      .col {
        color: #247af1;
        min-height: 90px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .is-odd {
      background: #fafafa;
      .col {
        color: #575757;
      }
    }
    .val {
      border-left: 1px solid #ececec;
      border-right: 1px solid #ececec;
    }
  }
  .organization {
    width: 100%;
  }
  .text-wrapper {
    padding: 0 40px;
    text-align: left;
    h2 {
      font-weight: 600;
    }
    h3 {
      font-weight: 600;
      line-height: 40px;
    }
    .item {
      padding: 20px 0;
    }
  }
}
</style>
